import type { RouteRecordRaw } from 'vue-router';
import { AUTH_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const confirmEmailRoutes: RouteRecordRaw = {
  path: '/confirm-email',
  component: () => import('@/layouts/public.vue'),
  meta: { i18n },
  children: [
    {
      path: '',
      name: AUTH_ROUTE_NAME.VERIFY_EMAIL,
      component: () => import('./ConfirmEmail.vue'),
      meta: { onlyGuest: true },
    },
  ],
};
